
import ProductMapMixin from "~/mixin/product-map-mixin";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";
import CheckoutMixin from "~/mixin/checkout-mixin";
import FormatMixin from "~/mixin/format-mixin";
import CalFloralCheckout from "~/components/checkout-flow/cal-floral-checkout.vue";
import CalNonFloralCheckout from "~/components/checkout-flow/cal-non-floral-checkout.vue";
import CalDriedFloralCheckout from "~/components/checkout-flow/cal-dried-floral-checkout.vue";
import CalBundleCheckout from "~/components/checkout-flow/cal-bundle-checkout.vue";
import CalSubscriptionCheckout from "~/components/checkout-flow/cal-subscription-checkout.vue";
import CalCartCountdownTimer from "~/components/cart/cal-cart-countdown-timer.vue";
import { butter } from "~/plugins/buttercms";
import CMSProduct from "~/types/cms/CMSProduct";
import CalSub6monthCheckout from "~/components/checkout-flow/cal-sub6month-checkout.vue";
import CalSub3monthCheckout from "~/components/checkout-flow/cal-sub3month-checkout.vue";
import CalOngoingSubscriptionCheckout from "~/components/checkout-flow/cal-ongoing-subscription-checkout.vue";
import CalSubscriptionMdayCheckout from "~/components/checkout-flow/cal-subscription-mday-checkout.vue";
import CalOtherAvailable from "~/components/cal-other-available.vue";

import CalCartPageBanner from "../components/cal-cart-page-banner.vue";
import { getCookieValueByName, setCookieValue } from "../utils/cookie";
const datadogErrorUrl = "datadog/events/error";
const cartCacheExpiryTime = 0.02083333333; //30 minutes as a fraction of 1 day

export default {
  name: "cart",
  mixins: [ProductMapMixin, ProcessLineItemsMixin, CheckoutMixin, FormatMixin],
  components: {
    CalFloralCheckout,
    CalNonFloralCheckout,
    CalSubscriptionCheckout,
    CalDriedFloralCheckout,
    CalBundleCheckout,
    CalCartCountdownTimer,
    CalSub6monthCheckout,
    CalSub3monthCheckout,
    CalOngoingSubscriptionCheckout,
    CalSubscriptionMdayCheckout,
    CalCartPageBanner,
    CalOtherAvailable,
  },
  data() {
    return {
      cartItems: [] as any[],
      lineItems: {
        bouquest: {},
      } as any | null,
      displayProductType: "",
      displayProductTags: [] as string[],
      discountCode: "",
      cartMessage: "",
      showCartDialog: false,
      expandIndexs: [] as any[],
      subscriptionCMSData: [] as CMSProduct[],
      isLoadAddons: false,
      isTriggerCartCountDown: false,
      notificationSlides: [],
      pageData: {},
      isReLoadRecipientDialog: false,
      clickedCheckout: false,
      latestProductAddedSku: sessionStorage["currentProductSku"] || "",
    };
  },
  watch: {
    notificationSlides() {
      if (this.notificationSlides.length > 0) {
        this.$store.dispatch("global/HIDE_ANNOUNCEMENT_BAR");
      }
    },
    cartItems() {
      this.updateLatestProductSku();
    },
  },
  beforeDestroy() {
    this.$store.dispatch("global/SHOW_ANNOUNCEMENT_BAR");
  },
  async created() {
    await this.updateLatestProductSku();
    await this.getMultishipBannerData();
    this.loadExistingCartItems();
    this.$nuxt.$on("cartItemsUpdated", () => {
      this.loadExistingCartItems();
    });
    this.scrollToDiv("main-layout");

    await this.createCartCache();
    this.discountCode =
      this.$store.state.lineItems.discountCode.length > 0
        ? this.$store.state.lineItems.discountCode
        : this.discountCode;
  },
  methods: {
    scrollToDiv(id: string) {
      const targetDiv = document.getElementById(id);

      if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: "smooth" });
      }
    },
    async updateLatestProductSku() {
      try {
        if (this.cartItems && Object.keys(this.cartItems).length > 0) {
          let keys = Object.keys(this.cartItems);
          let firstItem = this.cartItems[keys[0]];
          if (firstItem?.product?.sku) {
            this.latestProductAddedSku = firstItem.product.sku;
          }
        }else{
          await this.logDataDogEvent("LATEST-PRODUCT-SKU-NOT-UPDATED");
        }
      } catch (error) {
        console.error("Error updating latest product SKU:", error);
        this.latestProductAddedSku = "";
        await this.logDataDogEvent("LATEST-PRODUCT-SKU-NOT-UPDATED");
      }
    },
    async updateCartCache() {
      try {
        let cartId = getCookieValueByName("cart_id");
        if (cartId && sessionStorage.cartItems) {
          await this.$axios.put(
            "cart",
            { sessionId: cartId, cart: sessionStorage.cartItems },
            {}
          );
        }
      } catch (err) {
        console.error("Error updating cart cache:", err);
      }
    },
    async createCartCache() {
      try {
        let cartId = getCookieValueByName("cart_id");
        if (!cartId && sessionStorage.cartItems) {
          const res = await this.$axios.post(
            "cart",
            { cart: sessionStorage.cartItems },
            {}
          );
          if (res?.status === 200 && res?.data?.id) {
            setCookieValue("cart_id", res.data.id, {
              expires: cartCacheExpiryTime,
            });
          }
        } else if (cartId) {
          const res = await this.$axios.put(
            "cart",
            { sessionId: cartId, cart: sessionStorage.cartItems },
            {}
          );
          if (res?.status === 200 && res?.data?.id) {
            setCookieValue("cart_id", res.data.id, {
              expires: cartCacheExpiryTime,
            });
          }
        }
      } catch (err) {
        console.error("Error creating cart cache:", err);
      }
    },
    async loadExistingCartItems() {
      try {
        const existingSessionCartItems = sessionStorage.cartItems
          ? JSON.parse(sessionStorage.cartItems)
          : null;
        if (
          existingSessionCartItems &&
          typeof existingSessionCartItems === "object"
        ) {
          this.cartItems = existingSessionCartItems;
          this.$store.dispatch(
            "lineItems/FILL_CART_ITEMS",
            existingSessionCartItems
          );
          this.lineItems = this.parseCartItemsToLineItems(this.cartItems);
          this.getDiscountCode();
          this.updateCartCache();
        } else {
          this.cartItems = {};
          this.$store.dispatch("lineItems/FILL_CART_ITEMS", {});
          await this.logDataDogEvent("SESSION-CART-ITEMS-NOT-FOUND");
        }
      } catch (error) {
        console.error("Error loading cart items:", error);
        this.cartItems = {};
        this.$store.dispatch("lineItems/FILL_CART_ITEMS", {});
        await this.logDataDogEvent("SESSION-CART-ITEMS-NOT-FOUND");
      }
    },
    onClickEdit(id: number) {
      const cartItem: any = this.cartItems[id];
      sessionStorage.deliveryDate = cartItem.deliveryDate;
      sessionStorage.deliveryTown = JSON.stringify(cartItem.deliveryTown);
      sessionStorage.editCartItemId = id;
      this.displayProductType = cartItem.product.productType.key;
      this.displayProductTags = cartItem.product.tags;
      this.$store.dispatch("cartItem/CART_ITEM_SET", cartItem);
      this.isLoadAddons = !this.isLoadAddons;
      this.isReLoadRecipientDialog = !this.isReLoadRecipientDialog;
      this.showCartDialog = true;
      this.$nuxt.$emit("hideChat");
    },
    closeCardDialog() {
      this.$store.dispatch("cartItem/CART_ITEM_FLUSH");
      this.displayProductType = "";
      this.showCartDialog = false;
      sessionStorage.removeItem("editCartItemId");
      this.$nuxt.$emit("showChat");
    },
    onClickDelete(id: number) {
      const removeItem = this.cartItems[id];
      delete this.cartItems[id];
      this.cartItems = { ...this.cartItems };
      this.$store.dispatch("lineItems/DELETE_CART_ITEM", id);

      const cartKeys = Object.keys(this.cartItems);
      if (cartKeys.length > 0) {
        const nextItem = { ...this.cartItems[cartKeys[0]] };
        // replace the delivery window with same day order when delete the parent/ main order
        if (
          nextItem &&
          nextItem.sameDayDelivery &&
          nextItem.sameDayDelivery.isSameAddressOrder
        ) {
          nextItem.deliveryWindow = removeItem
            ? removeItem.deliveryWindow
            : null;
          this.$store.dispatch("lineItems/UPDATE_CART_ITEM", nextItem);
        }
      }
      sessionStorage.cartItems = JSON.stringify(
        this.$store.state.lineItems.cartItems
      );
      this.$nuxt.$emit("cartItemsUpdated");
      this.isTriggerCartCountDown = !this.isTriggerCartCountDown;
      this.updateCartCache();
    },
    async onClickCheckout() {
      await this.updateCartCache();
      this.clickedCheckout = true;
      try {
        this.cartCheckout(
          this.$i18n.getLocaleCookie(),
          this.lineItems,
          this.cartItems,
          this.$store,
          this.discountCode,
          getCookieValueByName("cart_id")
            ? { cart_id: getCookieValueByName("cart_id") }
            : {}
        );
      } catch (err) {
        console.error(err);
        await this.$axios.$post(
          datadogErrorUrl,
          {
            error: {
              name: "CANT-PROCEED-PAST-CHECKOUT",
              ddSessionId: this.getatadogSessionID(),
            },
          },
          {}
        );
      }
    },
    bouquetName(item: any) {
      return item.parentProductTitle;
    },
    bouquetImage(item: any) {
      return item?.product?.image?.imageURL;
    },
    bouquetCost(item: any) {
      return this.getPriceWithLocale(item.price);
    },
    vaseName(item: any) {
      return item.title;
    },
    vaseCost(item: any) {
      return this.getPriceWithLocale(item.price);
    },
    subsAddonName(item: any) {
      return item.titleView;
    },
    subsAddonCost(item: any) {
      return this.getPriceWithLocale(item.price);
    },
    addonName(addon: any) {
      return addon.title;
    },
    addonCost(addonRecord: any) {
      const { addon: item } = addonRecord;
      if (item != null) {
        let qty = 0;
        if (addonRecord.quantity && addonRecord.quantity > 0) {
          qty = addonRecord.quantity;
        }
        let costFinal: number;
        let cost = item.variant?.price?.amount;
        if (cost != null) {
          if (item.title?.toLowerCase().includes("greet")) {
            costFinal = cost * qty;
          } else {
            costFinal = Math.trunc(cost) * qty;
          }
          return this.getPriceWithLocale(costFinal);
        }
      }
    },
    greetCost(item: any) {
      return this.getPriceWithLocale(item.price);
    },
    deliveryRateName(item: any) {
      return item.deliveryWindow.title;
    },
    deliveryRatePrice(item: any) {
      return this.getPriceWithLocale(
        item.deliveryWindow.productVariant.price.amount
      );
    },
    cardName(item: any) {
      return item.card.title;
    },
    productKey(item: any) {
      return item.productType ? item.productType.key : "";
    },
    cardPrice(item: any) {
      let price = item.card.productVariants[0].price.amount;
      if (price !== "0.0") {
        return this.getPriceWithLocale(price);
      } else {
        return "";
      }
    },
    totalCost() {
      let cost: number = 0;

      for (const cartItem of Object.values(this.cartItems)) {
        cost += this.calculateBouquetPrice(cartItem.product);
        cost += this.calculateGreetPrice(cartItem.greet);
        cost += this.calculateGreetPrice(cartItem.upgrade);
        cost += this.calculateVasePrice(cartItem.vase);
        cost += this.calculateAddonsPrice(Object.values(cartItem.addons));
        // Reusing addons logic for donations
        cost += this.calculateAddonsPrice(Object.values(cartItem.donations));
        cost += this.calculateCardPrice(cartItem.card);
        cost += this.calculateShippingCostPrice(cartItem.deliveryWindow);
      }

      let finalCost: number;
      if (this.frac(cost) === 0) {
        finalCost = Math.trunc(cost);
      } else {
        finalCost = cost;
      }
      return this.getPriceWithLocale(finalCost);
    },
    frac(f: number) {
      return f % 1;
    },
    calculateBouquetPrice(item: any) {
      return +item.price;
    },
    calculateGreetPrice(item: any) {
      return item.price ? +item.price : 0;
    },
    calculateVasePrice(item: any) {
      return item.addon ? +item.addon.price : 0;
    },
    calculateAddonsPrice(item: any) {
      let cost = 0;
      for (const addonRecord of item) {
        const price = addonRecord.addon.price;
        const quantity = addonRecord.quantity;
        cost += price * quantity;
      }
      return cost;
    },
    calculateCardPrice(card: any) {
      return +this.getPriceWithLocale(
        card.productVariants[0].price.amount
      ).replace("$", "");
    },
    calculateShippingCostPrice(item: any) {
      return +this.getPriceWithLocale(item.productVariant.price.amount).replace(
        "$",
        ""
      );
    },
    calculateSubsAddonPrice(item: any) {
      return item.addon ? +item.addon.price : 0;
    },
    async getDiscountCode() {
      try {
        const response = await this.$axios.post(
          `/discount`,
          JSON.stringify(Object.values(this.cartItems)),
          { headers: { "callia-lang": this.$i18n.locale } }
        );
        this.discountCode =
          response.data.code.length > 0
            ? response.data.code
            : this.discountCode;
        this.cartMessage = response.data.message;
      } catch (error) {
        console.error(error);
      }
    },
    cartItemExpansion(index: any) {
      if (this.expandIndexs.indexOf(index) > -1) {
        this.expandIndexs.splice(this.expandIndexs.indexOf(index), 1);
      } else {
        this.expandIndexs.push(index);
      }
    },
    async getSubscriptionContent() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["subscriptions"],
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        this.subscriptionCMSData = this.mapCMSProducts(
          response,
          "subscriptions"
        );
      } catch (error) {
        throw new Error(`Ooops somethings is not right !!! ${error}`);
      }
    },
    deliveryDate(date: any) {
      return this.$dayjs(date).format("dddd, MMMM Do, YYYY");
    },
    deliveryInfo(item: any) {
      return (
        this.$t("for") +
        " " +
        item.recipient.firstName +
        " " +
        item.recipient.lastName +
        " " +
        this.$t("on") +
        " " +
        this.deliveryDate(item.deliveryWindow.deliveryDate)
      );
    },
    async getMultishipBannerData() {
      try {
        const page = await butter(this.$config).page.retrieve(
          "*",
          "cart-page",
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        this.pageData = page?.data.data.fields;
      } catch (error) {
        console.error(error);
      }
    },
    // TODO: Move this code into a shared file if this method need in any other place.
    async logDataDogEvent(name:any) {
      try {
        await this.$axios.$post(datadogErrorUrl, {
          error: {
            name,
            ddSessionId: this.getatadogSessionID()
          },
        });
      } catch (err) {
        console.error("Data Dog logging failed:", err);
      }
    }
  },
  async fetch() {
    await this.getSubscriptionContent();

    try {
      const response = await butter(this.$config).content.retrieve(
        ["announcement_bar"],
        {
          locale: this.$i18n.locale,
          timeout: 10000,
        }
      );

      for (const bar of response.data.data["announcement_bar"]) {
        if (bar.announcement_bar_items.length > 0) {
          for (const item of bar.announcement_bar_items) {
            if (item.name === "Cart Page Announcement") {
              this.notificationSlides = bar.announcement_bar_items;
              this.$store.dispatch("global/HIDE_ANNOUNCEMENT_BAR");
              break;
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  },
};
